module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "مدرسة_الفان_الخاصة-الفصل_الثاني-عشر_ج"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("#مدرسة_الفان_الخاصَّة "), _c('br'), _vm._v("#الفصل_الثّاني عشر_ج")])]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "width": "2.78125in",
      "height": "0.33647in"
    },
    attrs: {
      "alt": " ",
      "src": "media/file1.png"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مرَّتِ الحصصُ الأولى سريعًا نوعًا ما، لكن هذه الحصة تبدو وكأنَّها ستستمرُّ إلى الأبد، الخمول بسبب الجوع يسيطر على طلَّاب الفصل، لا أحد منهم ينظرُ باتِّجاه الأستاذ البدين حتَّى، أمبر ترسمُ الدَّوائر بالقلم على صفحة الكتابِ غير مباليةٍ للكلمات التي صارت تختفي تحتَ الحبر الأسوَد السائل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ليسا وإيلي تتجادلان حول اللَّون الرائج للأحذية في هذا الموسم، بينما يتراسلان باستخدام هواتفهما المخفيَّة داخل أدراج الطاولة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مارك حشر إحدى روايات الجيب البوليسيَّة لإرسين لوبين")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn1",
      "id": "fnref1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("داخل كتاب الأحياء البيئيَّة، يقرأُ في متعةٍ متظاهِرًا بالتَّركيز مع الأستاذ الذي يبدو فخورًا به.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يزن نائمٌ كالموتى، جاكسون وكريس حتمًا أخذهما التفكير إلى مكان آخَر، والذي لَم يكن درس أستاذ الأحياء البيئيَّة مِن الأساس بالتأكيد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جهرَ المعلِّم بصوتٍ حادٍّ، لكنَّ ذهنَ جاكسون كان خارج التَّغطية تمامًا:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- جاكسون، فلتقرأ الجزءَ الأخير مِن الصفحة التَّاسعة عاليًا، هيه! أنتَ، أليس اسمك الذي طُرِّز على سترتك المدرسي جاكسون؟")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مهلًا! لِمَ ترتدي سترة طالب آخَر؟ أنا أحدِّثُك؛ لذا قِف وأجِب فورًا وإلَّا...!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جاكسون جعلَ الأستاذ يبتلع بقيَّة حديثه حين قام واقفًا متَّجِهًا إلى الخارج مِن غير أن ينبس ببنت شفة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تجعَّد جبينُ الأستاذ دلالةً على الغضب، إلَّا إنَّه ما لبث أن تنحنح ليعود ويكمل قراءة الدَّرس.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم تمضِ ثوانٍ حتَّى سرَت همهمةٌ أفقدَتهُ تركيزه، ليرفع رأسه عن الكتاب، وتجحظ عيناه في حيرة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إنَّه مارك، الطَّالب المثالي والوحيد الذي كان يركِّز معه طوال الحصَّة كما يظنُّ، يخرجُ خلفَ صديقه في برود!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("خطواتُ جاكسون بين أروقة المدرسة كانت متباينة، ولكنَّها كانت أكثر حيويَّة مِن خلايا جسده الخاملة أثناء الدَّرس، رفع يديه إلى الأعلى وهو يفتح رئتيه مستنشِقًا الهواء البارد المنعش ليشعر بشيء يرتطم بظهره بقوَّة، التفَت ليجدَ مارك خلفَه بابتسامةٍ هادئةٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أشارَ مارك إلى السترة الملقاةِ تحتَ قدم جاكسون:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سترتُك!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أسرَع الأخير بخلع سترة صديقه، وارتدى خاصَّته في مرحٍ، إلَّا إنَّه ما لبث أن قهقهَ حين التقَت عيناه بذلك الجسدِ الضئيل القصير نوعًا ما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أشارَت أمبر نحوَ جاك:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ياااه! أنتَ، ألن تيئَس مِن لعب دور العاشق المعذَّب؟ أنتَ تعلم أنَّ إيلي تحبُّك كما تحبُّ القهوة؛ لذا لا تحزن.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جاك في حيرة:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ولكنَّها لا تحبُّ القهوة أبدًا!")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- تمامًا!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حاول مارك كتمَ ضحكته وهو يحيطُ بذراعيه كلًّا مِن أمبر وجاكسون ليجرَّهما نحو الحديقة الخلفيَّة حيث ملعب كرة السلة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخذوا مقاعدهم على مدرَّجاتِ الملعب الخاوية، جاكسون ملتفِتًا إلى أمبر:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هل وقعتِ في الحبِّ يومًا؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مارك متسائلًا:")])]), _vm._v(" "), _c('ul', {
    staticClass: "line"
  }, [_c('li', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يا تُرى مَن الذي قد ترغبُ أمبر في مواعدتهِ؟")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هي فقط أخذَت نفَسًا عميقا لتتنهَّد بعدها قائلة:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- "), _c('strong', [_vm._v("شخص يتفهَّمُني، يحبُّني كيفما أنا، يحبُّ أخطائي قبل صوابي، يحبُّ عالمي كما يحبُّني، إممم.. يكبرُني بالكثير مِن السنواتِ؛ لأنِّي لا أحبُّ علاقاتِ الأطفال، يقعُ لسحر كلماتي الصادقة منها والكاذبة، يقبِّلُني فقط في المساء، وماذا أيضًا؟ شخص يحبُّ مشاهدة الأفلام وسماع الموسيقى الغريبة.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ظهرَت علاماتُ الخيبة على جاكسون، في حين صار مارك يهزُّ رأسَه باستنكار.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمبر في حنقٍ:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ماذا؟")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  })])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جاكسون:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- "), _c('strong', [_vm._v("هو يجبُّ أن يكونَ شخصًا يأخذكِ بين يديه، ويُريَكِ العالمَ في جوفِ عينيه، يجعل قلبَكِ ينبضُ بجنونٍ، يوصلكِ إلى هاويةِ اللَّاوعي!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مارك في هيامٍ دراميّ:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- شخص تفضِّلين مشاهدته يبتسمُ، عِوَضًا عن مشاهدة الأفلام معه، صوتُه معزوفةٌ نادرةٌ لأذنيكِ تُغنِيكِ عن سماعِ الموسيقى الغريبة التي تحبِّين.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمبر في خيبة أمل:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('strong', [_vm._v("- توك توك توك! يبدو أنَّكما في حاجة ماسَّةٍ إلى الإقلاع عن مشاهدةِ الأفلام والمسلسلات الرُّومانسيَّة اللَّاواقعيَّة يا رفاق")]), _vm._v("!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوتُ حادُّ مألوف اخترق أسماعهم، لن يخطئه أيٌّ مِن طلابِ المدرسة، صوت ليسا وإيلي:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- إ"), _c('strong', [_vm._v("نَّهم هنا.. أسرِعوا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جاكسون ينظرُ إلى مارك متسائلًا، ومارك ينفي براحتَي يديه قائلًا:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- صدِّقني! لا أعرف لِمَ الجميع هنا، فحِصَّة الأحياء البيئيَّة لَم تنتهِ بعد!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانَ جميع طلَّاب فصل الثاني عشر حقبة (ج) قد وصلوا إلى المدرَّجات حين علَت قهقهاتُ أمبر")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ليسا بغير تصديقٍ:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- جاك! أنتَ لم ترَ وجهَ المعلّمِ البدين الذي كان يبدو كالمصعوقِ حينَ وقفَت أمبر فجأةً معلِنةً انتهاء الحصَّة، لتخرجَ بعدَها بشكلٍ طبيعيٍّ جعلَه يسعلُ لمرَّاتٍ عدَّة مِن غير أن ينطقَ بحرفٍ واحد!")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  })])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمبر في غير مبالاةٍ:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كانت قد تبقَّت عشرُ دقائقَ بغيضةٍ على وقت الاستراحة، لا أظنُّه يمانع سعادةَ طلابه في")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تناول وجبة إفطارِهم مبكِّرًا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم تكد تنهي حديثها حتَّى علَتِ الأجراسُ معلنةً بدء الوقتِ المنتظَر للطلاب، وهي استراحة الإفطار.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إيلي سحبَت أمبر التي بدَت وكأنَّها ستسحبُ شعرَها غضبًا بأي لحظةٍ، ليتَّجها إلى حيث ليسا:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أمبر، تعالَي لنأكلَ، أسرِعي.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الثلاثةُ غرفْنَ مِن الطَّعام الكثير كالمعتاد، لكن ليسا وإيلي كانَتا الأكثر تذمُّرًا على أنواع الطَّعام وطريقة طهيه، مِمَّا جعلهما يأخذان كثيرًا مِن الوقت.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمبر فقط قرَّرَتِ العودة إلى الطاولة في مللٍ، تعثَّرت قليلًا عندما مرَّت بجانب طالبٍ طويلٍ بعض الشيء، ليضربَ بذراعه ظَهرَ أمبر التي شهقَت بخفوت وألمٍ، لعنَت داخليًّا، بينَما تكبحُ الشعورَ المؤلِمَ المتحجِّرَ أسفل ظهرها، ولكنَّ الفتى التفتَ أكثر ليجعلَها تسكب القليلَ جدًّا مِن الصحنِ الذي تحمله على الأرض، وهنا كانتِ المفاجأة! إنَّهُ كريس، الطالبُ الجديدُ ذو عصبةِ الرَّأس زاهية الألوان.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمبر اعتذرَت بلُطفٍ؛ فهي المخطِئةُ، ويجب عليها الاعتذار ببساطةٍ:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- آسفة.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كريس في استفزاز:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- "), _c('strong', [_vm._v("آسفة! هذا مضحكٌ! هل تودِّين استبدالَ المغفرة بلكمةٍ؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عقدَت أمبر حاجبيها في استنكارٍ، هي حقًّا ليسَت في مزاجٍ للشِّجار في أوَّل يوم دراسي بالسنة الأخيرة:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وهل يمكنُكَ الابتعاد؟ لقد اعتذرتُ بالفعل، الآن وداعًا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هي حاولَت المُضِيَّ قُدُمًا لتتجاوزَه، إلَّا إنَّهُ أمسك بمعصمها بقوَّةٍ، لترتدَّ إلى الخلف:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنتِ لن تذهبي بسهولة، فأنا أحبُّ الحديثَ مطوَّلًا مع الأقزام!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جميعُ مَن كان في غرفة استراحة الطَّعام التفَت إلى ما يدور بين الطالبَين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رفعَ الفتَى ذو الشَّعر الأسوَد الكثيفِ والمدعو يزن رأسَه عنِ الطَّاولة قائلًا في جذلٍ:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أ"), _c('strong', [_vm._v("مبر! لقَد بدأَ المرحُ مبكِّرًا هذه المرَّة!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هبَّ جاكسون واقفًا وهو يُمسكُ بقميصِ مارك يحثُّه على الوقوف.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مارك متذمِّرًا بفمٍ مليءٍ بالطَّعامِ:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ياااه! اتركني، هي تستطيع تدبُّر نفسها جيِّدًا.. قلتُ دعني!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("علا صوتُ الطلاب بحماسٍ حين وضعَت أمبر صحنَها على طاولةٍ ما خلفَها لتلتفِتَ نحو كريس محافِظةً على ابتسامةٍ ساخرةٍ تزيِّنُ وجهَها الصَّغير:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- دعْنا نوقفُ هذه المهزلةَ الغبيَّة قبلَ أن تبدأَ أيُّها الملوَّن!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لكنَّ كريس تجاهلَها ليجمعَ أصابعَ يدهِ ويكوِّرها، مصَوِّبًا اللكمة نحو عينِ أمبر اليُمنَى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هي لَم تتزحزح قيدَ أنملة، فقطَ وقفَت في المكان نفسه، تحملُ الابتسامةَ الساخرة ذاتها بكلِّ هدوءٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حبسَ الجميعُ أنفاسهم ليعودوا ويزفروا براحةٍ حين أصابَت قبضة كريس الهواء على بُعد إنشات قليلة مِن أمبر التي أطلقَت ضحكةً عاليةً أثارَت استغراب الجميع.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كريس وهو يربت على كتفه:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ضربُ النِّساء لا يناسبُ شخصيَّتي.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمبر وهي تعقد ذراعيها أمامَ صدرها:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ولكنَّني أظنُّكَ تناسبُ ذوقي يا رجل!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تناولَ كريس صحن أمبر ليقدِّمَهُ لها باسمًا:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أصدقاء.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمبر وهي تعودُ أدراجها نحو رفاقها:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا يبدو الأمر سَيِّئًا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تبعها كريس، واستطاع رؤية الأعين الكثيرة التي تحدِّقُ بأمبر في اهتمام وترقُّبٍ، هي تبدو شعبيَّة للغاية، وهو لَم يستطِع إنكار الجزء الحسود الذي بدأ ينمو داخله، إلَّا إنَّ فكرة كونها تقبَّلَتهُ كصديقِ دراسة أعجبَته حقًّا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخذ الاثنان مقاعدهما بجوار رفاقهما في الشعبة (ج)، لينظرَ الجميعُ بعدَها نحو كريس في توجُّسٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جاكسون في سخرية:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أكانَ يتوجَّبُ عليك صُنعَ كلِّ هذه الدِّراما للجلوس على طاولتنا؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تجاهلَ كريس النَّظر إليه، ليردفَ جاكسون بغضبٍ:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لماذا لا تنظر إليَّ أثناء الحديث؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كريس في برود")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هل يجبُ عليَّ ذلك؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جاءت إجابة جاكسون ساخرة:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وهل يحتاج ذلك إلى سؤالٍ؟!")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنا لا أحبُّ التَّحديقَ المتواصِلَ في الآخرين مثلك جاك.")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- مثلي! آه.. حقًّا! ما الذي تعرفُه عنِّي كريس؟")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنتَ تحدِّقُ بي منذُ التقيتُكَ في الصباح.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أزاح جاكسون صحنه مِن أمامه مجيبًا:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أترى في الأمر مشكلةً حين تحدِّق في شخصٍ غريبٍ عليك؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هسهس كريس، وقد بدأَت عيناه تشتعل غضبًا:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنتَ، لِمَ تجيب الأسئلة بالأسئلة؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمبر نفد صبرُها لتقاطعهما بصوتٍ أعلى:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هل تتشاجران يا رفاق؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أجاب الاثنان بصوت واحد:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم تستطِع الفتياتُ إخفاء ضحكتهنَّ، في حين حاولَ البقيَّة ابتلاعها حتَّى لا يثِرن غضب أمبر أكثر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قرقعةُ الأشواك والملاعق على الصحون وهمهمات الطلاب أثناء تناول وجبتهم، حثَّت عقارب الساعة على الإسراع في المضِيّ إلى نهاية وقت الاستراحة حين عانَقَت عقارب الساعة بعضها مشيرةً إلى الحادية عشرة صباحًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('hr'), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "fn1"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شخصية خيالية ابتكَرها الكاتب الفرنسي موريس لوبلان.")]), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref1"
    }
  }, [_vm._v("↩︎")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f48c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch009.vue
// module id = 90
// module chunks = 0